/**
 * SPEC-71 §3C — session-kick reason codes → user-facing copy.
 *
 * Mirrors `nfc-login-copy.ts`: a pure code→string map plus a total function
 * with a generic fallback. The machine codes are the ones `routes/auth.ts`'s
 * refresh handler emits (`refresh_revoked`, `device_binding_required`,
 * `device_unbound`, `device_replay_detected`) plus the generic `unauthorized`
 * used for any other 401 (a replay-still-401, a forged jti, or an unparsable
 * body). `api.ts`'s `notifyUnauthorized(reason)` carries the code; App's
 * listener renders the copy.
 *
 * An UNKNOWN/missing code falls back to the default "Signed out." — never
 * blank, never the raw machine string.
 */
export const SESSION_KICK_COPY: Record<string, string> = {
  refresh_revoked:
    "Session ended — your sign-in was reset (PIN change, passkey reset, or office device reset). Sign in again.",
  device_binding_required:
    "This device needs to re-verify with the yard NFC tag. Sign in with a tag scan.",
  device_unbound:
    "This device was unbound (signed out elsewhere or reset by the office). Sign in again with a tag scan.",
  device_replay_detected:
    "Session conflict detected — sign in again to secure your account.",
  unauthorized: "Session expired. Sign in again.",
};

/** The copy for a kick reason; the default when the code is absent/unknown. */
export function kickCopy(reason?: string): string {
  if (!reason) return "Signed out.";
  return SESSION_KICK_COPY[reason] ?? "Signed out.";
}